import { Component } from '@angular/core';

@Component({
  selector: 'app-academic-following',
  standalone: true,
  imports: [],
  templateUrl: './academic-following.component.html',
  styleUrl: './academic-following.component.css'
})
export class AcademicFollowingComponent {

}
